import { ValidationModel, ValidationType } from "@/services/validation/types";

export const postCommonValidators = {
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel,
    showTime: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 1000000 }
        ]
    } as ValidationModel
};
